import { render, staticRenderFns } from "./FilterBoxHeader.vue?vue&type=template&id=6e708ef2&scoped=true&"
import script from "./FilterBoxHeader.vue?vue&type=script&lang=js&"
export * from "./FilterBoxHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e708ef2",
  null
  
)

export default component.exports